import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f847b1d8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f847b1d8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f847b1d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f847b1d8')) {
      api.createRecord('f847b1d8', component.options)
    } else {
      api.reload('f847b1d8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f847b1d8&scoped=true", function () {
      api.rerender('f847b1d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/automaticSortings/returnNote/index.vue"
export default component.exports